import { render, staticRenderFns } from "./quit_commend.vue?vue&type=template&id=02acb612&scoped=true"
import script from "./quit_commend.vue?vue&type=script&lang=ts"
export * from "./quit_commend.vue?vue&type=script&lang=ts"
import style0 from "./quit_commend.vue?vue&type=style&index=0&id=02acb612&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02acb612",
  null
  
)

export default component.exports